import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { CategoryProduct } from '../interfaces/category-product';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment.prod';
import { CategoryProductFilter } from '../interfaces/category-product-filter';

@Injectable({
  providedIn: 'root'
})
export class CategoryProductService {

  private endpoint: string = environment.apiUrl;

  constructor(private http: HttpClient) { }

  categoryProductList(data: CategoryProduct): Observable<any> {
    return this.http.post<any>(this.endpoint + 'dap-category-by-id', data);
  }

  categoryProductFilterList(data: CategoryProductFilter): Observable<any> {
    return this.http.post<any>(this.endpoint + 'filters-by-products', data);
  }
}